import { useEffect, useState } from "react";
import {
  FiAlignRight,
  FiFacebook,
  FiInstagram,
  FiMail,
  FiPhoneCall,
} from "react-icons/fi";
import { NavLink } from "react-router-dom";
import logo from "../../assets/logo/AK_black.webp";

const Navbar = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [rightAnimation, setRightAnimation] = useState("animate__slideInUp");
  const [leftAnimation, setLeftAnimation] = useState("animate__slideInDown");
  const [isRotated, setIsRotated] = useState(false);

  const toggleVisibility = () => {
    if (isVisible) {
      setRightAnimation("animate__slideOutDown");
      setLeftAnimation("animate__slideOutUp");
      setTimeout(() => {
        setIsVisible(false);
        setIsRotated(false);
      }, 900);
    } else {
      setIsVisible(true);
      setRightAnimation("animate__slideInUp");
      setLeftAnimation("animate__slideInDown");
      setIsRotated(true);

      // Delay setting background to avoid blocking initial render
      setTimeout(() => {}, 100); // Delay by 100ms
    }
  };

  useEffect(() => {
    document.body.style.overflow = isVisible ? "hidden" : "auto";
  }, [isVisible]);

  return (
    <header className="w-full h-[80px] bg-white relative z-30">
      <nav className="w-full h-full">
        <div className="h-full container flex items-center justify-between">
          <div
            className="relative z-50 mix-blend-difference text-black"
            id="logo"
          >
            <NavLink to="/">
              <h1 className="uppercase text-white text-sm md:text-lg">
                kavalier photographer
              </h1>
            </NavLink>
          </div>
          <div className="relative z-50 text-black">
            <button
              className={`p-2 text-2xl bg-white rounded-full transform transition-transform ${
                isRotated ? "rotate-180" : ""
              }`}
              onClick={toggleVisibility}
            >
              <FiAlignRight />
            </button>
          </div>
        </div>

        {isVisible && (
          <div
            className="absolute z-40 top-0 left-0 h-screen w-full overflow-hidden"
            id="toggled-menu"
          >
            <div className="h-full flex flex-row items-center justify-center ">
              {/* Left Section */}

              <div
                id="left"
                className={`h-full w-5/12 md:w-5/12 animate__animated ${leftAnimation} bg-[var(--cerna)]`}
              >
                <div className="w-full h-full flex items-center justify-center">
                  <img src={logo} alt="" />
                </div>
              </div>
              {/* Right Section */}
              <div
                id="right"
                className={`h-full w-7/12 md:w-7/12 bg-white animate__animated ${rightAnimation}`}
              >
                <div className="w-full h-full flex flex-col items-center justify-center relative z-40">
                  <div
                    className="container flex flex-col items-center justify-start"
                    id="menu-wrap"
                  >
                    <div className="flex flex-col gap-5 uppercase" id="menu">
                      {[
                        { path: "/", label: "domů" },
                        { path: "/galerie", label: "galerie" },
                        // { path: "/vanoce", label: "vánoce" },
                        { path: "/svatby", label: "svatby" },
                        { path: "/o-mne", label: "o mně" },
                        { path: "/kontakt", label: "kontakt" },
                      ].map(({ path, label }) => (
                        <div
                          className="group transition duration-300 w-fit"
                          key={path}
                        >
                          <NavLink to={path} onClick={toggleVisibility}>
                            {label}
                            <span className="block max-w-0 group-hover:max-w-full transition-all duration-300 h-0.5 bg-slate-400"></span>
                          </NavLink>
                        </div>
                      ))}

                      {/* Socials - optional */}
                      <div
                        className="hidden flex-wrap items-center gap-5"
                        id="socials-wrap"
                      >
                        <a
                          href="https://www.facebook.com/kavalierAd"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <div className="p-2 text-xl rounded hover:bg-slate-200 ">
                            <FiFacebook />
                          </div>
                        </a>
                        <a
                          href="https://www.instagram.com/kavalier__photographer/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <div className="p-2 text-xl rounded hover:bg-slate-200 ">
                            <FiInstagram />
                          </div>
                        </a>
                        <a
                          href="mailto:adela.kavalirova@seznam.cz"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <div className="p-2 text-xl rounded hover:bg-slate-100 ">
                            <FiMail />
                          </div>
                        </a>
                        <a
                          href="tel:+420732613904"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <div className="p-2 text-xl rounded hover:bg-slate-200 ">
                            <FiPhoneCall />
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Navbar;
